
//赛道颜色判断
export const contestCheck = (contestType: number): 'warning' | 'success' | 'danger' | 'primary' | 'info' => {
    if (contestType === 0) {
        return 'warning'
    } else if (contestType === 1) {
        return 'success'
    } else if (contestType === 2) {
        return 'danger'
    }
    else if (contestType === 3) {
        return 'primary'
    }
    return 'info'
}

//显示赛道名称
export const checkContestName = (contestType: number): string => {
    if (contestType === 0) {
        return '编程挑战'
    } else if (contestType === 1) {
        return '音乐创作'
    } else if (contestType === 2) {
        return '动画视频'
    }
    else if (contestType === 3) {
        return '创意挑战'
    }
    return '其他'
}
